import React from 'react';
import {Link} from 'react-router-dom';

import "./omni-search-tabs.scss";

export const OmniSearchTabs = ({queryParam}) => {
    const pathname = window.location.pathname

    return (
        <HeaderWithTabs text={`${queryParam ? '"' + decodeURI(queryParam) + '"' : ''}`} >
            <TabList>
                <Tab {...{
                    text: "Explore",
                    to: `explore${persistentSearchQuery(queryParam)}`,
                    selected: pathname.includes("explore"),
                }}/>
                <Tab {...{
                    text: "Products & Templates",
                    to: `browse${persistentSearchQuery(queryParam)}`,
                    selected: pathname.includes("browse"),
                }}/>
            </TabList>
        </HeaderWithTabs>
    )
}

const HeaderText = ({text}:{text:string}) => (
    <div className="header-text-235711" xd-qa-type="label" xd-qa-name={text}>
        {text}
    </div>
)

const HeaderWithTabs = ({text, children}:{text:string, children:React.ReactNode}) => (
    <div>
        <header className="header-with-tabs-235711">
            <HeaderText text={text}/>
            {children}
        </header>
    </div>
)

const Tab = ({text, to, selected=false}:{text:string, to:string, selected?:boolean}) => (
    <Link {...{
        className:`tab-235711${selected ? ' selected' : ''}`,
        to,
        "xd-qa-type": "tab",
        "xd-qa-name": text,
    }}>
        {text}
    </Link>
)

const TabList = ({children}:{children:React.ReactNode}) => (
    <div className="tab-list-235711">
        {children}
    </div>
)

const persistentSearchQuery = (query) => {
    let appendage = ''
    if(query) {
        appendage = `?q=${query}`
    }
    return appendage
}